import actions from './actions';

const initState = {
    data: []
};

export default function FacilityBenchmarkReducer(state = initState, action) {
    switch (action.type) {
        case actions.FacilityBenchmark_SUCCESS:
            return {
                ...state,
                data: action.payload.data
            };
        default:
            return state;
    }
}
